class freeGift{
  constructor(){
      
  }

  addItem = async(formData) =>{
    try{
      const addcartData = await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
      const addcartRes = await addcartData.json();
      return addcartRes
    }catch(e){
      return e;
    }
  }
  
  changeItem = async (formData) =>{
    const addcartData = await fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    const addcartRes = await addcartData.json();
  }
  
  slabOffer = async (offer, cart, cartTotal) =>{
    let totalPrice = cartTotal;
    let offer1ProductExist = cart.items.find((item)=> item.id == offer.id && item.properties['_free_gift'])
    let update = false;
    if(totalPrice >= offer.price && !offer1ProductExist && totalPrice < offer.maxAmount){

      let formData = {
        'items': [{
         'id': offer.id,
         'quantity': 1,
          properties: {
            '_free_gift': true
          }
         }]
       };
       await this.addItem(formData);
      update = true;
    }else if(totalPrice < offer.price && offer1ProductExist){
        let formData = {
          'id': offer1ProductExist.key,
          'quantity': 0
        };
        await this.changeItem(formData)
        update = true;
    }else if(totalPrice >= offer.price && offer1ProductExist && offer1ProductExist?.quantity > 1){
        let formData = {
          'id': offer1ProductExist.key,
          'quantity': 1
        };
        await this.changeItem(formData)
        update = true;
    }else if(totalPrice >= offer.maxAmount && offer1ProductExist){
      let formData = {
        'id': offer1ProductExist.key,
        'quantity': 0
      };
      await this.changeItem(formData)
      update = true;
    }
    return update;
  }

  slabOffers = async (cart, cartTotal) =>{
    
    const offer1 = {
      price: 39900,
      id : 40607542444107,
      maxAmount: 89900
    }
    let update = false;
    const update1 = await this.slabOffer(offer1, cart, cartTotal);
    const offer2 = {
      price: 89900,
      id : 40942773108811,
      maxAmount: 129900
    }
    const update2 =  await this.slabOffer(offer2, cart, cartTotal);

    const offer3 = {
      price: 89900,
      id : 40013564543051,
      maxAmount: 129900
    }
    const update3 = await this.slabOffer(offer3, cart, cartTotal);
    
    const offer4 = {
      price: 129900,
      id : 40203629297739,
      maxAmount: 9999999999999999999999999900
    }
    const update4 = await this.slabOffer(offer4, cart, cartTotal);
    if(update1 || update2 || update3 || update4){
      update = true
    }
    return update;
  }

  updateItem = async(withBuyProduct, freeGift, cart, type="product", totalQ, extraProp) =>{
        let totalPrice = cart.total_price;
        let update = false;
        let totalQty = 0;
        let totalFindQty = 0;
    
        for(let i=0; i < cart.items.length; i++){
          let item = cart.items[i];
          if(type == "variant"){
            if(item.variant_id == withBuyProduct){
              totalQty = totalQty + item.quantity;
            }
          }else{
            if(item.product_id == withBuyProduct){
              totalQty = totalQty + item.quantity;
            }
          }
          
        }

    for(let i=0; i < cart.items.length; i++){
          let item = cart.items[i];
          if(item.variant_id == freeGift && item.properties[extraProp]){
            totalFindQty = totalFindQty + item.quantity;
          }
        }

        if(totalQ && totalQty != 0){
          totalQty = totalQ;
        }
        let findItemExist = cart.items.find((item)=> item.product_id == withBuyProduct);
        let findItem = cart.items.find((item)=> item.variant_id == freeGift && item.properties[extraProp]);
        if(totalQty > 0 && !findItem){
            let formData = {
                'items': [{
                 'id': freeGift,
                 'quantity': totalQty,
                  properties: {
                    '_free_gift': true,
                    [extraProp]: true
                  }
                 }]
               };
               await this.addItem(formData);
               update = true;
        }else if(totalQty > totalFindQty){
              let formData = {
                 'id': findItem.key,
                 'quantity': totalQty
               };
               await this.changeItem(formData)
               update = true;
        }else if(totalQty <= 0 && totalFindQty > 0){
          let formData = {
             'id': findItem.key,
             'quantity': 0
           };
           await this.changeItem(formData)
           update = true;
      }

          return update;
  }

  productEqualQtyBasedOffer = async (cart) =>{
      let update = false
     
      // const update1 = await this.updateItem(6867841122379, 41189108154443, cart, "product",null,"_free_gift_1");
      const update2 = await this.updateItem(40083156172875, 41223982055499, cart, "variant",null,"_free_gift_2");
      const update3 = await this.updateItem(41051950022731, 41175641718859, cart, "variant",null,"_free_gift_3");
    
      // if(update1 || update2 || update3)

      if(update2 || update3){
        update = true;
      }

      return update
  }

  productBasedOffer = async (cart) =>{
    let update = false
   

    const update1 = await this.updateItem(7169134166091, 41223861534795, cart, "product", 1, "_free_gift_4");
    const update2 = await this.updateItem(6656704938059, 41223948763211, cart, "product", 1, "_free_gift_5");
    // const update3 = await this.updateItem(7169144291403, 41143637999691, cart, "product", 1, "_free_gift_6");
    // const update4 = await this.updateItem(6868271038539, 41143637999691, cart, "product", 1, "_free_gift_7");
    // const update5 = await this.updateItem(6690056372299, 40929393213515, cart, "product", 1, "_free_gift_8");

    
    // withBuyProduct, freeGift, cart, type="product", totalQ, extraProp
    // if(update1 || update2 || update3 || update4 || update5){
    //   update = true;
    // }

    if(update1 || update2){
      update = true;
    }

    return update
  }
  
  init = async () =>{
    let data = await fetch('/cart.json');   
    let cart = await data.json();

    let res = await fetch('/cart?view=price');
    let htmlText= await res.text()
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlText, 'text/html');
    
    // Find the .cart-total element
    const price = doc.querySelector('.cart-total')?.dataset?.price;
    const cartTotal = parseInt(price);

    const update1 = await this.productEqualQtyBasedOffer(cart);
    const update2 = await this.slabOffers(cart,cartTotal);
    const update3 = await this.productBasedOffer(cart)
    if(update1 || update2){
        if(window.location.pathname == '/cart'){
            window.location.reload();
        }
    }
  }
}

window.freeGift = new freeGift();

document.addEventListener('DOMContentLoaded', function() {
  // Your code here will run after the document is fully loaded
  window.freeGift.init();
});
